import React from 'react';
import HomeScreenConfigForm from './HomeScreenConfigForm';

const CreateHomeScreenConfig = ({ show, onHide, prefill }) => (
  <HomeScreenConfigForm show={show} onHide={onHide} mode="create" initialRow={prefill || null} />
);

export default CreateHomeScreenConfig;
